





















import {
  defineComponent,
  computed,
  ref,
  watch
} from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { BundleItem } from '@wemade-vsf/magento-api';
import type { SelectedBundleProductOptions } from '@wemade-vsf/catalog/lib/runtime/product/helpers/bundleProduct';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import {
  getName as getProductName
} from '@wemade-vsf/catalog/lib/runtime/product/getters/productGetters';
import { useCustomerPricing } from '@wemade-vsf/catalog/lib/runtime/product/composables/useCustomerPricing';

export default defineComponent({
  name: 'BundleMultiRenderer',
  props: {
    bundle: {
      type: Object as PropType<BundleItem>,
      required: true
    },
    selectedOptions: {
      type: Object as PropType<SelectedBundleProductOptions>,
      required: true
    }
  },
  emits: ['update:selectedOptions'],
  setup (props, { emit }) {
    const { getPriceForProduct } = useCustomerPricing();
    const selected = ref<string[]>([]);

    const filteredBundleOptions = computed(() => {
      return (props.bundle as BundleItem).options?.filter((option) => option?.product) ?? [];
    });

    function emitChange() {
      const newSelectedOptions: Array<{uid: string, quantity: number, price: number}> = [];
      selected.value.forEach((optionUid) => {
        if (!optionUid || optionUid === 'none') return;
        const option = (props.bundle as BundleItem).options!.find((opt) => opt?.uid === optionUid);
        if (option && option.product) {
          newSelectedOptions.push({
            uid: option.uid,
            quantity: 1,
            price: getPriceForProduct(option.product as unknown as Product).final ?? 0
          });
        }
      });
      emit('update:selectedOptions', newSelectedOptions);
    }

    watch (() => props.selectedOptions, (value) => {
      selected.value = (value[(props.bundle as BundleItem).uid!] as any[])?.map((opt: any) => opt.uid) || [];
    }, { immediate: true });

    return {
      selected,
      emitChange,
      getProductName,
      getProductPrice: getPriceForProduct,
      filteredBundleOptions
    }
  }
});
